/**
 * Generic message interpreter that replaces {{placeholder}} patterns with provided parameters
 * @param message - The message template with {{placeholder}} patterns
 * @param params - Object containing key-value pairs for placeholder replacement
 * @returns The interpreted message with placeholders replaced
 */
export function interpretMessage(message: string, params: Record<string, any>): string {
    return message.replace(
        /\{\{([^}]+)\}\}/g,
        (_, key: string) => (params[key] !== undefined ? String(params[key]) : `{{${key}}}`),
    );
}
